import React from 'react';

import { flagStyles } from '../settings';

const SvgPK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4224px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPK;
